module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.ba82f344.webp";